<div class="col-lg-12 col-md-12 col-12">
    <div class="bk-title--default text-center mb--70">
         <h6 class="heading heading-h6 theme-color"></h6>
         <div class="bkseparator--30"></div>
         <h3 class="heading heading-h3"><br>Activador Akashico<sup>®</sup>Niños Practicante</h3>
     </div>
     <div class="row">
        
         <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9611529128.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Lucrecia Matuz Colmenares</li>
                     <li>lck.2904.matuz@gmail.com </li>
                     <li>TEL. 9611529128</li>
                     <li>Tuxtla Gutiérrez, Chiapas</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
          <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9612527752.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Susana Cruz Constancio</li>
                     <li>susyconst@hotmail.com</li>
                     <li>TEL. 9612527752</li>
                     <li>Tuxtla Gutiérrez, Chiapas</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
              <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9621529296.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>María de los Ángeles Ramos Moreno</li>
                     <li>Angeles.ramos@hotmail.com</li>
                     <li>TEL. 9621529296</li>
                     <li>Tapachula, Chiapas</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
         
                        
         
         
         
         
         

       
     </div>
 </div>
